import { ArcElement, Chart, Legend, PieController, Tooltip } from "chart.js";
import { CHART_COLORS } from "../default/components/FleetSummaryPieChart";

Chart.register(ArcElement, Tooltip, Legend, PieController);

const whiteBackground = {
  id: "reportPieWhite",
  beforeDraw(chart) {
    const { ctx, width, height } = chart;
    ctx.save();
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, width, height);
    ctx.restore();
  },
};

export function piePng(slices) {
  const canvas = document.createElement("canvas");
  canvas.width = 720;
  canvas.height = 420;
  const rows = slices || [];
  const chart = new Chart(canvas, {
    type: "pie",
    data: {
      labels: rows.map((slice) => slice.label || ""),
      datasets: [{
        data: rows.map((slice) => Number(slice.value) || 0),
        backgroundColor: rows.map((slice, index) => slice.color || CHART_COLORS[index % CHART_COLORS.length]),
        borderColor: "#ffffff",
        borderWidth: 1,
      }],
    },
    options: {
      animation: false,
      responsive: false,
      plugins: {
        legend: {
          display: true,
          position: "bottom",
          labels: {
            color: "#1B2559",
            font: { size: 13 },
            generateLabels(chartInstance) {
              const colors = chartInstance.data.datasets[0]?.backgroundColor || [];
              return rows.map((slice, index) => ({
                text: `${slice.label || ""} (${slice.value ?? 0})`,
                fillStyle: colors[index] || CHART_COLORS[index % CHART_COLORS.length],
                strokeStyle: "#ffffff",
                lineWidth: 1,
                hidden: false,
                index,
                datasetIndex: 0,
              }));
            },
          },
        },
        tooltip: { enabled: false },
      },
    },
    plugins: [whiteBackground],
  });
  const url = canvas.toDataURL("image/png");
  chart.destroy();
  return url;
}
